import { render, staticRenderFns } from "./eVerifyDuplicates.vue?vue&type=template&id=96c565d6&"
import script from "./eVerifyDuplicates.vue?vue&type=script&lang=js&"
export * from "./eVerifyDuplicates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports